import {Calculator, ChevronDown, Menu, X} from 'lucide-react'
import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

const calculatorLinks = [
  { to: '/calculators/budget-50-30-20', label: 'Budget (50/30/20)' },
  { to: '/calculators/net-worth', label: 'Net Worth' },
  { to: '/calculators/emergency-fund', label: 'Emergency Fund' },
  { to: '/calculators/mint-loan', label: 'Loan Amortization' },
  { to: '/calculators/credit-card-payoff', label: 'Credit Card Payoff' },
  { to: '/calculators/mortgage-payoff', label: 'Mortgage Payoff' },
  { to: '/calculators/nft-mint-cost', label: 'NFT Mint Cost' },
  { to: '/calculators/solana-mint-cost', label: 'Solana Mint Cost' },
  { to: '/calculators/silver-coin-value', label: 'Silver Coin Value' },
  { to: '/calculators/gold-eagle-mint', label: 'Gold Eagle Mint Value' },
]

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [calcOpen, setCalcOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/15 text-emerald-400">
            <Calculator className="h-5 w-5" />
          </span>
          <span className="text-lg font-bold tracking-tight text-slate-50">
            Mint
            {' '}
            <span className="text-emerald-400">Calculator</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          <div
            className="relative"
            onMouseEnter={() => setCalcOpen(true)}
            onMouseLeave={() => setCalcOpen(false)}
          >
            <button className="flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-slate-300 transition-colors hover:text-emerald-400">
              Calculators
              <ChevronDown className="h-3.5 w-3.5" />
            </button>
            {calcOpen && (
              <div className="absolute left-0 top-full w-64 rounded-xl border border-slate-800 bg-slate-900 p-2 shadow-xl shadow-black/40">
                {calculatorLinks.map(link => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    className={({ isActive }) => `block rounded-lg px-3 py-2 text-sm transition-colors ${isActive ? 'bg-emerald-500/10 text-emerald-400' : 'text-slate-300 hover:bg-slate-800 hover:text-slate-50'}`}
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          <NavLink to="/about" className={({ isActive }) => `rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'text-emerald-400' : 'text-slate-300 hover:text-emerald-400'}`}>
            About
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => `rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'text-emerald-400' : 'text-slate-300 hover:text-emerald-400'}`}>
            Contact
          </NavLink>
        </nav>

        <div className="hidden lg:block">
          <Link to="/calculators/budget-50-30-20" className="rounded-lg bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-950 transition-colors hover:bg-emerald-400">
            Start Calculating
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-800 text-slate-300 lg:hidden"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-slate-800 bg-slate-950 px-4 py-3 lg:hidden">
          <p className="mb-2 px-2 text-xs font-semibold uppercase tracking-widest text-slate-500">Calculators</p>
          <div className="grid grid-cols-1 gap-1">
            {calculatorLinks.map(link => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) => `rounded-lg px-3 py-2 text-sm ${isActive ? 'bg-emerald-500/10 text-emerald-400' : 'text-slate-300 hover:bg-slate-800'}`}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
          <div className="mt-3 grid grid-cols-1 gap-1 border-t border-slate-800 pt-3">
            <NavLink to="/about" onClick={() => setMobileOpen(false)} className="rounded-lg px-3 py-2 text-sm text-slate-300 hover:bg-slate-800">About</NavLink>
            <NavLink to="/contact" onClick={() => setMobileOpen(false)} className="rounded-lg px-3 py-2 text-sm text-slate-300 hover:bg-slate-800">Contact</NavLink>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
